import React, { Component } from 'react';
import PropTypes from 'prop-types';
import dc, {d3, crossfilter} from 'dc';
import * as chartsUtilFunctions from './util/chartsUtilFunctions';
import * as utilFunctions from './util/utilFunctions';
import BaseChart from './baseChart';
import $ from "jquery";
 
class CoordinateBaseChart extends BaseChart {
  constructor(props, context) {
    super(props, context);
    this.state = utilFunctions.mergeState(this.state, {
      config: utilFunctions.mergeState(this.state.config, {
          xAxis: {
            label:"",
            labelPadding: 25,
            axisPadding: 5,
            padding:42,
            interval:1,
            intervalDateUnit:"DAY",
            rotation: 0,
            format:"",
            autoRange:{active:true,min:0,max:1,fixWidth:false},
            show: true
          },
          yAxis: {
            label:"",
            labelPadding: 25,
            axisPadding: 5,
            padding: 42,
            format:"",
            ticksNumber: null,
            horizontalLines: false,
            factor: 1,
            factorOperator: "*",
            autoRange:{active:true,min:0,max:1},
            show: true       
          },
          showNulls: false,
          colorRangeParser: [],
          colorRange:[]
        }),
      composeCharts: [],
      type: "",
      continuousLabels: [],
      discreteLabelsNumber: 1
    });     
    this.handleOnFiltered = this.handleOnFiltered.bind(this);
  }

  getChartTypeInstance() {
    throw "Method getChartTypeInstance() must be implemented and return a dc.chart (composite, line or bar)";
  }

  getChartCompositeInstance() {
    throw "Method getChartTypeInstance() must be implemented and return a dc.chart (line or bar)";
  }

  generateContinuousLabels(min,max) {
    if(this.props.dimension.reduceFunction.type == "CONTINUOUS_GROUP") {
      while(this.state.continuousLabels.length > 0) {
        this.state.continuousLabels.pop();
      }
      var step = 1;
      if(this.props.dimension.reduceFunction.typeof =="DATE_TIME") {
        step = 24*60*60*1000;
      }      
      for(var i=min; i<=max;i=i+step) {
        this.state.continuousLabels.push(i);
      }
    }
  }

  setXAxisContinuousDomain() {
    if(this.props.dimension.reduceFunction.type == "CONTINUOUS_GROUP") {
      var runFormatFunctions = chartsUtilFunctions.runFormatFunctions;
      var min;
      var max;

      if(this.state.config.xAxis.autoRange.active == false) {
        min = runFormatFunctions(this.props.dimension.formatFunction,this.state.config.xAxis.autoRange.min);
        max = runFormatFunctions(this.props.dimension.formatFunction,this.state.config.xAxis.autoRange.max);
      }
      else{
        //si no hay datos
        if(typeof this.state.crossfilter.getDim().bottom(1)[0] == "undefined") {    
          switch(this.props.dimension.reduceFunction.typeof) {
            case "NUMBER":
              min = 0;
              max = 1;
              break;
            case "DATE_TIME":
              min = new Date();
              max = new Date();
              break;
          }
        }
        else {
          min = runFormatFunctions(this.props.dimension.formatFunction,this.state.crossfilter.getDim().bottom(1)[0][this.props.dimension.name]);
          max = runFormatFunctions(this.props.dimension.formatFunction,this.state.crossfilter.getDim().top(1)[0][this.props.dimension.name]);          
        }
        this.state.chart.elasticX(false);
      }
      this.generateContinuousLabels(min,max);
      switch(this.props.dimension.reduceFunction.typeof) {
        case "NUMBER":
          if(this.state.config.xAxis.interval) {
            var intervalBoundary = this.state.config.xAxis.interval/2;
            if(this.state.type == "LINE") {
              intervalBoundary = 0;
            }
            this.state.chart      
              .x(d3.scale.linear().domain([min-intervalBoundary,max+intervalBoundary]))
              .xAxis().tickValues(d3.range(min, max+0.1, this.state.config.xAxis.interval));
          }
          else {
            this.state.chart      
            .x(d3.scale.linear().domain([min,max]));  
          }
          if(this.state.config.xAxis.format) {          
            this.state.chart      
              .xAxis().tickFormat(d3.format(this.state.config.xAxis.format));
          }        
          break;
        case "DATE_TIME":
          var units = d3.time.months;
          var ticks = d3.time.month;
          if(this.state.config.xAxis.interval) {
            var intervalBoundary = this.state.config.xAxis.interval/2;
            var secondsStep = 0; //for UTC
            if(this.state.type == "LINE") {
              intervalBoundary = 0;
            }
            switch(this.state.config.xAxis.intervalDateUnit) {
              case "YEAR":
                secondsStep = 12*30*24*60*60; //for UTC
                if(min instanceof Date) {                 
                  min.setMonth(min.getMonth() - Math.round(intervalBoundary*12));
                  max.setMonth(max.getMonth() + Math.round(intervalBoundary*12));
                }
                units = d3.time.years;
                ticks = d3.time.year;
                break;
              case "MONTH":
                secondsStep = 30*24*60*60; //for UTC
                if(min instanceof Date) { 
                  min.setDate(min.getDate() - Math.round(intervalBoundary*30));
                  max.setDate(max.getDate() + Math.round(intervalBoundary*30));
                }
                units = d3.time.months;
                ticks = d3.time.month;
                break;
              case "DAY":
                secondsStep = 24*60*60; //for UTC
                if(min instanceof Date) { 
                  min.setHours(min.getHours() - Math.round(intervalBoundary*24));
                  max.setHours(max.getHours() + Math.round(intervalBoundary*24));
                }
                units = d3.time.days;
                ticks = d3.time.day;
                break;
            }
            if((min instanceof Date)==false) { //for UTC
              if(this.state.type != "LINE") {
                intervalBoundary = 0.5;
              }
              min = min - Math.round(intervalBoundary*secondsStep*1000);
              max = max + Math.round(intervalBoundary*secondsStep*1000);
            }
            this.state.chart     
              .x(d3.time.scale().domain([min,max]))
              .xUnits(units)
              .xAxis().ticks(ticks, this.state.config.xAxis.interval);
          }
          else
          {
            this.state.chart     
              .x(d3.time.scale().domain([min,max]));
          }
          if(this.state.config.xAxis.format) { 
            this.state.chart     
              .xAxis().tickFormat(d3.time.format(this.state.config.xAxis.format));
          }
          break;
      }
    }
  }

  setXAxisDiscreteDomain() {
    if(this.props.dimension.reduceFunction.type == "DISCRETE_GROUP") {
      if("parameters" in this.props.dimension.reduceFunction) {
        this.state.chart
          .x(d3.scale.ordinal().domain(this.props.dimension.reduceFunction.parameters.labels))
          .xUnits(dc.units.ordinal);  
      }
      else {
        var metrics = this.state.crossfilter.getMetrics();
        var labels = [""];
        if(metrics.length>0) {
          var metric = metrics[0].all();
          if(metric.length>0) {
            labels = [];
          }
          for(var i=0;i<metric.length;i++) {
            labels.push(metric[i].key);
          }
        }
        this.state.discreteLabelsNumber = labels.length;
        this.state.chart
          .x(d3.scale.ordinal().domain(labels))
          .xUnits(dc.units.ordinal);
        
        if(this.state.config.xAxis.format 
          && this.state.config.xAxis.format=="CLEAN") {           
          this.state.chart     
            .xAxis().tickFormat((function(v) {
              var vAux = v;
              if(this.state.config.xAxis.interval) {
                var i = 0;
                var find=false;
                for(i;i<labels.length;i++) {
                  if(labels[i]==vAux){
                    find = true
                    break;
                  }
                }

                if(find && i%this.state.config.xAxis.interval!=0) {
                  vAux="";
                }
              }
              var splittedLabel = vAux.split("|");
              if(splittedLabel.length>1) {
                return splittedLabel[1];
              }
              return vAux;           
            }).bind(this));
        }
      }
    }
  }

  setAxis() {
    if(this.state.config.xAxis.show == true) {
      this.state.chart
      .xAxisLabel(this.state.config.xAxis.label);
      this.state.chart.margins().bottom = this.state.config.xAxis.padding;
      if(this.state.config.xAxis.label != "") {
        this.state.chart.margins().bottom += this.state.config.xAxis.labelPadding;
      }
    }

    if(this.state.config.yAxis.show == true) {
      this.state.chart 
      .yAxisLabel(this.state.config.yAxis.label);
      this.state.chart.margins().left = this.state.config.yAxis.padding;
      if(this.state.config.yAxis.label != "") {
        this.state.chart.margins().left += this.state.config.xAxis.labelPadding;
      }
    }

    this.state.chart
      .brushOn(false);

    switch(this.props.dimension.reduceFunction.type) {
      case "DISCRETE_GROUP":
        this.setXAxisDiscreteDomain(); 
        break;
      case "CONTINUOUS_GROUP":
        this.setXAxisContinuousDomain();
        break;
    }

    if(this.state.config.yAxis.autoRange.active == false) {
      this.state.chart      
        .y(d3.scale.linear().domain([this.state.config.yAxis.autoRange.min, this.state.config.yAxis.autoRange.max]));
    }
    else {
      this.state.chart.elasticY(true);
    }

    if(this.state.config.yAxis.ticksNumber) {
      this.state.chart 
        .yAxis().ticks(this.state.config.yAxis.ticksNumber);
    }

    this.state.chart
      .renderHorizontalGridLines(this.state.config.yAxis.horizontalLines);

    if(this.state.config.yAxis.format) {
      var formatFunction = utilFunctions.getFormatFunction({
          "type":"NUMBER",
          "format": this.state.config.yAxis.format,
          "factorOperator": this.state.config.yAxis.factorOperator,
          "factor": this.state.config.yAxis.factor
        });
      this.state.chart      
        .yAxis().tickFormat(formatFunction);
    }

    this.state.chart.margins().right = 15; 

    if(this.state.config.xAxis.show == false) {
      this.state.chart.xAxis().ticks(0);
      this.state.chart.xAxisPadding(0);   
      this.state.chart.margins().top = 5; 
      this.state.chart.margins().bottom = 5;  
    }

    if(this.state.config.yAxis.show == false) {
      this.state.chart.yAxis().ticks(0);
      this.state.chart.yAxisPadding(0); 
      this.state.chart.margins().left = 5; 
      this.state.chart.margins().right = 5; 
    }         
  } 

  initializeBasicChartConfig() {
    super.initializeBasicChartConfig();
    this.setAxis();
  }

  setMetrics() {
    var metrics = this.state.crossfilter.getMetrics();
    var ensureGroupBins = chartsUtilFunctions.ensure_group_bins;

    for(var i=0;i<metrics.length;i++) {
      var metric = metrics[i];
      if(this.props.dimension.reduceFunction.type == "CONTINUOUS_GROUP" 
        && this.state.type == "LINE") {
        ensureGroupBins = ensureGroupBins.bind(null,metric);
        metric = ensureGroupBins(null, this.state.continuousLabels);
      }
      if(this.props.stack) {
        if(i==0) {
          this.state.chart.group(metric,metric.name);
        }
        else {
          this.state.chart.stack(metric,metric.name);
        }
      }
      else {   
        if(this.state.config.showNulls) {     
          this.state.composeCharts[i] = this.getChartCompositeInstance()
            .group(metric,metric.name)        
            .valueAccessor(p => {
              var value = (this.state.crossfilter.getValueAccesor())(p);
              if(value==null) {
                return 0;
              }
              else {
                return value;
              }
            });
        }
        else {
          this.state.composeCharts[i] = this.getChartCompositeInstance()
            .group(metric,metric.name)        
            .valueAccessor(this.state.crossfilter.getValueAccesor());
        }
      }
    }

    if(this.props.stack) {
      this.state.chart
        .valueAccessor(this.state.crossfilter.getValueAccesor());
    }
    else {
      this.state.chart
        .compose(this.state.composeCharts);
    } 
  }

  stylingAndFormat() {
    if(this.props.stack) {
      this.state.chart        
        .colors(d3.scale.ordinal().range(this.state.config.colors));
    }
    else
    {
      var colors = this.state.config.colors;

      for(var i=0;i<this.state.composeCharts.length;i++) {
        if(this.props.metrics.length > 1 || this.props.dimension.reduceFunction.type == "CONTINUOUS_GROUP") {
          if(i>=this.state.config.colors.length) {
            colors = [this.state.config.colors[i%this.state.config.colors.length]]; 
          }
          else {
            colors = [this.state.config.colors[i]];
          }          
        }
        this.state.composeCharts[i].onClick = function() {};
        this.state.composeCharts[i].filter = function() {};
        this.state.composeCharts[i]
          .colors(d3.scale.ordinal().range(colors))
          .colorAccessor(function (d,i){return i;});
      }
    }
  }

  handleOnFiltered(e,data) {
    //fix de auto scale
    if(this.props.dimension.reduceFunction.type == "CONTINUOUS_GROUP" 
        && this.state.config.yAxis.autoRange.active == true) {
      this.state.chart.render();     
    }
  }

  componentDidMount() {
    super.componentDidMount(); 
    $("body").on('filtered'+this.props.dashboardId, this.handleOnFiltered);
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    $("body").off('filtered'+this.props.dashboardId, this.handleOnFiltered);
  } 


  preRenderOperations() {
    super.preRenderOperations();
    this.setXAxisContinuousDomain();
    this.setXAxisDiscreteDomain(); 
  }

  postRenderOperations() {
    super.postRenderOperations();

    this.state.chart.svg().selectAll("g.x text")
      .attr('transform', 'translate(0,' + this.state.config.xAxis.axisPadding + ') rotate(' + (-this.state.config.xAxis.rotation) + ')');
    this.state.chart.svg().selectAll("g.y text")
      .attr('transform', 'translate(-' + this.state.config.xAxis.axisPadding + ',0)');

    if(this.state.config.xAxis.rotation==90) {
      this.state.chart.svg().selectAll("g.x text")
        .style('text-anchor','end');
      this.state.chart.svg().selectAll("g.x text")
        .attr('transform', 'translate(-14,10) rotate(' + (-this.state.config.xAxis.rotation) + ')');
    }
    else if(this.state.config.xAxis.rotation>0) {
      this.state.chart.svg().selectAll("g.x text")
        .style('text-anchor','end');
    }  
    else if(this.state.config.xAxis.rotation<0){
      this.state.chart.svg().selectAll("g.x text")
        .style('text-anchor','start');
    }   

    if(this.state.chart.svg().selectAll('.dc-tooltip .xRef') && 
      (this.state.config.tooltip.lines == "HORIZONTAL" || this.state.config.tooltip.lines == "NONE")) {
      this.state.chart.svg().selectAll('.dc-tooltip .xRef').remove(); 
    }

    if(this.state.chart.svg().selectAll('.dc-tooltip .yRef') && 
      (this.state.config.tooltip.lines == "VERTICAL" || this.state.config.tooltip.lines == "NONE")) {
      this.state.chart.svg().selectAll('.dc-tooltip .yRef').remove(); 
    }


      var xAxis = this.state.chart.svg().selectAll(".axis.x");
      var xAxisPath = this.state.chart.svg().selectAll(".axis.x path");
      var chartBody = this.state.chart.svg().selectAll(".chart-body");
      var rangesWrapper = this.state.chart.svg().insert("g",":first-child")
        .attr("transform",chartBody.attr("transform"));

    for(var i=0;i<this.state.config.colorRange.length;i++) {
      var ranges = this.state.config.colorRange[i];
      var rangeValues = [];
      var color = ranges.color;
      var top = this.state.chart.yAxis().scale().domain()[1];
      var bottom = this.state.chart.yAxis().scale().domain()[0]; 

      if(top==bottom) {
        top=top+2;
        this.state.chart.yAxis().scale().domain([bottom,top]);
      }  

      if(ranges.range.length == 1 
        && (ranges.range[0].operator == "<" || ranges.range[0].operator == "<=")
        && bottom<ranges.range[0].value) {
        rangeValues[rangeValues.length] = bottom;
      }
      if(ranges.range.length == 1 
        && (ranges.range[0].operator == ">" || ranges.range[0].operator == ">=")
        && top>ranges.range[0].value) {
        rangeValues[rangeValues.length] = top;
      }

      for(var j=0;j<ranges.range.length;j++) {
        rangeValues[rangeValues.length] = ranges.range[j].value;
      }

      rangeValues.sort(function(a,b) {return a-b});
      rangeValues = rangeValues.slice(0,2);
   
      if(rangeValues.length == 2) {
        if(this.state.config.yAxis.autoRange.active == true) {          
          if(rangeValues[0]>=top || rangeValues[1]<=bottom) {
            continue;
          }
          rangeValues[1] = Math.min(top,rangeValues[1]);
          rangeValues[0] = Math.max(bottom,rangeValues[0]);
        }

        var height= Math.abs(this.state.chart.y()(rangeValues[1])-this.state.chart.y()(rangeValues[0]));
        rangesWrapper.append("rect")
          .attr("height", height)
          .attr("width",xAxisPath.node().getBBox().width)
          .attr("y",this.state.chart.y()(rangeValues[1]))
          .attr("x",0)
          .style("fill",color)
          .style("opacity",1);
      } 
    } 

    if(this.state.config.xAxis.show == false) {
      d3.select("#"+this.props.id).classed("hideXAxisSelector",true);
    }
    else {
      var _this = this;
      this.state.chart.svg().selectAll(".axis.x .tick")
        .each(function(d) {
            if(d instanceof Date) {
              var element = d3.select(this);
              var elementWidth = element.node().getBBox().width;
              var date = d;
              d.setTime(d.getTime()-d.getTimezoneOffset()*60000);
              d3.select(this).attr("transform","translate("+(_this.state.chart.x()(d.getTime()))+",0)");
            }              
        });      
    }
    if(this.state.config.yAxis.show == false) {
      d3.select("#"+this.props.id).classed("hideYAxisSelector",true);
    }
  } 
}


export default CoordinateBaseChart;

//color config example {"colors":["#CCC"]} uno solo si no hay rangos o 
//{"colors":["#CCC","#DDD",]} o uno por rango
//para crear rangos de datos reduce_function:
//pivotes tambien aceptan params filter: '{"dimension":"name_driver_client","value":"Sebastian Bravo"}'
//"type":"DISCRETE_GROUP","parameters":{"categories":[[{"value":1,"operator":">="},{"value":1,"operator":"<="}],[{"value":2,"operator":">="},{"value":2,"operator":"<="}],[{"value":3,"operator":">="},{"value":3,"operator":"<="}],[{"value":4,"operator":">="},{"value":4,"operator":"<="}],[{"value":5,"operator":">="},{"value":5,"operator":"<="}]],"labels":["1-1","2-2","3-3","4-4","5-5"]}
/*linear - piecewise linear segments, as in a polyline.
linear-closed - close the linear segments to form a polygon.
step - alternate between horizontal and vertical segments, as in a step function.
step-before - alternate between vertical and horizontal segments, as in a step function.
step-after - alternate between horizontal and vertical segments, as in a step function.
basis - a B-spline, with control point duplication on the ends.
basis-open - an open B-spline; may not intersect the start or end.
basis-closed - a closed B-spline, as in a loop.
bundle - equivalent to basis, except the tension parameter is used to straighten the spline.
cardinal - a Cardinal spline, with control point duplication on the ends.
cardinal-open - an open Cardinal spline; may not intersect the start or end, but will intersect other control points.
cardinal-closed - a closed Cardinal spline, as in a loop.
monotone - cubic interpolation that preserves monotonicity in y.*/



// WEBPACK FOOTER //
// ./source/client/components/common/graphs/crossfilterGraphs/coordinateBaseChart.jsx